import { SortableField } from '@wix/ambassador-devcenter-ams-v1-app-market-search/types';
import { SortType } from '../tag-apps';

export function mapSortTypeToSortableField(sortType: SortType): SortableField {
  switch (sortType) {
    case SortType.COUNTRY_CODE:
      return SortableField.COUNTRY_CODE;
    case SortType.APP_MARKET_SCORE:
      return SortableField.APP_MARKET_SCORE;
    case SortType.DEALER:
      return SortableField.DEALER;
    case SortType.DATE_CREATED:
      return SortableField.FIRST_PUBLISH_DATE;
    case SortType.REVIEWS_RATING:
      return SortableField.REVIEWS_RATING;
    case SortType.MOST_INSTALLED:
      return SortableField.MOST_INSTALLED;
    case SortType.MANUAL:
      return SortableField.MANUAL_ORDER;
    case SortType.ML_MODEL_RANKING:
      return SortableField.ML_RANKING;
    default:
      return SortableField.DEFAULT;
  }
}
